import { render, staticRenderFns } from "./InventBomVersion.vue?vue&type=template&id=6dfb5d6e"
import script from "./InventBomVersion.vue?vue&type=script&lang=js"
export * from "./InventBomVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports